var $ = require('jquery');

$(document).ready(function () {
    initTabs();
});

function initTabs() {
    $('.approach__tab-triggers__item').off('click').on('click', function (e) {
        e.preventDefault();
        const index = $(this).attr('data-tab-index');
        const sectionName = $(this).data('active-item');
        $('.approach__tabs__item').removeClass('active');
        $('.approach__tab-triggers__item').removeClass('active');
        $('.approach__tabs__item[data-tab-index="' + index + '"]').addClass('active');
        $(this).addClass('active');

        if ($(this).data('active-item').length > 0) {
            $('.section-arros-download__logo').removeClass('active');
            $('.section-arros-download__content--inner').removeClass('active');
            $('.section-arros-download__bg').removeClass('active');
            $('.section-arros-download__logo[data-name="' + sectionName + '"]').addClass('active');
            $('.section-arros-download__content--inner[data-name="' + sectionName + '"]').addClass('active');
            $('.section-arros-download__bg[data-name="' + sectionName + '"]').addClass('active');
        }
    });
}